export default __webpack_public_path__ + "static/media/3-6-2.5b176f3d.webp";